module.exports = __webpack_public_path__ + "img/51_49.269f6ffe.png";